import { useQuery } from "react-query";
import { fetchFileContent } from "../mutations/file.mutations";

export const useFileContent = ({ id }: { id: number | string | undefined }) => {
  return useQuery(["files", id], async () => {
    try {
      return fetchFileContent(id);
    } catch (err) {
      return null;
    }
  });
};
